import script from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./StableTokenPill.vue?vue&type=style&index=0&id=289593ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-289593ec"]])

export default __exports__